module.exports = "<h1 translate>Something went wrong</h1> <p class=type-h5 translate>Something went wrong when loading this page.</p> <p class=type-h5 translate>Contact <a href=mailto:support@profficina.be class=link>support@profficina.be</a> for further assistance.</p> <p>Error 500 - Internal Server Error</p> <br/>";


//////////////////
// WEBPACK FOOTER
// ./features/checkout/cart-error.html
// module id = 571
// module chunks = 0